import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/industries/mssp')({
  head: () => ({
    ...buildSeoHead({ path: '/industries/mssp', ...ROUTE_META['/industries/mssp'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Industries', path: '/industries' }, { name: 'MSSP', path: '/industries/mssp' }])),
      jsonLdScript(buildWebPageSchema({ path: '/industries/mssp', ...ROUTE_META['/industries/mssp'] })),
    ],
  }),
});
